
import { Base } from '../base-component';
import { TooltipsService } from '../../services/tooltips.service';
import { AnalyticsService } from '../../services/analytics.service';
import './newsletter.component.scss';

declare var newsLetterSiteName;

export class Newsletter extends Base {

	// small newsletter
	submitButtonSmall: any;
	containerDetailsText: any;
	containerDetailsForm: any;
	containerDetailsCompleted: any;
	textHeading: any;
	textDescription: any;
	fieldEmail: any;
	storage: any;
	buttonDone: any;
	
	// modal newsletter
	forms: any;
	formId: any;
	modalButtons: any;
	modalButtonsClose: any;
	modalContainers: any;
	activeModal: any;
	checkboxes: any;
	buttonSelectAll: any;
	buttonSelectClear: any;
	containerModalForm: any;
	containerModalLoader: any;
	containerModalSuccess: any;
	submitButtonModal: any;
	selectedCheckboxes: any;
	sitename: any;

	constructor(element: Element){

		super(element);

	}

	init(){

		// small newsletter
		this.submitButtonSmall = this.element.querySelector('.js-newsletter-submit-small');
		this.containerDetailsText = this.element.querySelector('.newsletter__details--text');
		this.containerDetailsForm = this.element.querySelector('.newsletter__details--form');
		this.containerDetailsCompleted = this.element.querySelector('.newsletter__details--completed');
		this.textHeading = this.element.querySelector('.js-newsletter-small-heading');
		this.textDescription = this.element.querySelector('.js-newsletter-small-description');
		this.fieldEmail = this.element.querySelector('.js-newsletter-small-email');
		this.buttonDone = this.element.querySelector('.js-newsletter-small-done');
		let checkStorage: any = localStorage.getItem('newsletter-entry');
		if (checkStorage) {
			this.storage = checkStorage;
		}
		this.checkNewsletterEntry();

		// modal newsletter
		this.forms = Array.from(this.element.querySelectorAll('form'));
		this.containerModalForm = this.element.querySelector('.newsletter__container-modal--form');
		this.containerModalLoader = this.element.querySelector('.newsletter__container-modal--loader');
		this.containerModalSuccess = this.element.querySelector('.newsletter__container-modal--success');
		this.modalButtons = Array.from(this.element.querySelectorAll('.js-newsletter-modal-open'));
		this.modalButtonsClose = Array.from(this.element.querySelectorAll('.js-newsletter-modal-close'));
		this.modalContainers = Array.from(this.element.querySelectorAll('.js-newsletter-modal'));
		this.checkboxes = Array.from(this.element.querySelectorAll('.js-newsletter-modal-checkbox'));
		this.submitButtonModal = Array.from(this.element.querySelectorAll('.js-newsletter-submit-modal'));
		this.buttonSelectAll = Array.from(this.element.querySelectorAll('.js-newsletter-selectall'));
		this.buttonSelectClear = Array.from(this.element.querySelectorAll('.js-newsletter-clearselected'));
		this.selectedCheckboxes = [];
		this.sitename = newsLetterSiteName;
		TooltipsService.initTooltips();

	}

	bindEvents() {

		// small newsletter
		if(this.submitButtonSmall){
			this.submitButtonSmall.addEventListener('click', (event) => {
				const element = event.target;
				const form = element.closest('form');
				const formFields: any = form.querySelectorAll('input, select');
				const validation = this.validationService.validate(formFields);
				if(typeof validation === 'object'){
					if (validation.valid) {
						this.actionSmallNewsletter(form);
					}
				}else{
					const valid = Array.from(form.querySelectorAll(".form__group--error"));
					if (valid.length == 0) {
						this.actionSmallNewsletter(form);
					}
				}
			});
		}

		if(this.buttonDone) {
			this.buttonDone.addEventListener('click', (event) => {
				this.containerDetailsCompleted.classList.remove('d-block');
				this.containerDetailsCompleted.classList.add('d-none');
				this.containerDetailsText.classList.remove('d-none');
				this.containerDetailsText.classList.add('d-block');
				this.containerDetailsForm.classList.remove('d-none');
				this.containerDetailsForm.classList.add('d-block');
				this.resetForms();
			});
		}

		// modal newsletter
		if (this.modalButtons) {
			this.modalButtons.map((item) => item.addEventListener('click', (event) => {
				let element;
				if (event.currentTarget) {
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				this.formId = element.getAttribute('data-modal');
				this.openModal(element.getAttribute('data-modal'));
			}));
		}

		if(this.modalButtonsClose){
			this.modalButtonsClose.map((item) => item.addEventListener('click', (event) => {
				this.analyticsService.dtmFormAbandon();
				this.modalContainers.map((item)=> {
					item.classList.add('modal--close');
					setTimeout(() => {
						item.classList.add('modal--closed');
						item.classList.remove('modal--close');
						this.resetForms();
					}, 250);
				})
			}));
		}

		if(this.modalContainers) {
			this.modalContainers.map((item) => item.addEventListener('click', (event) => {
				let element = event.target;
				if(element.getAttribute('id') === this.activeModal) {
					this.analyticsService.dtmFormAbandon();
					this.modalContainers.map((item)=> {
						item.classList.add('modal--close');
						setTimeout(() => {
							item.classList.add('modal--closed');
							item.classList.remove('modal--close');
							this.resetForms();
						}, 250);
					})
				}
			}));
		}

		if (this.buttonSelectAll) {
			this.buttonSelectAll.map((item) => item.addEventListener('click', (event) => {
				this.checkboxes.map((checkbox) => {
					checkbox.checked = true;
				});
				this.buttonSelectClear.map((button) => {
					button.classList.add('d-block');
				});
				this.submitButtonModal.map((button) => {
	
				});
				this.submitButtonModal.map((button)=>{
					button.classList.remove('button--disabled');
				})
			}));
		}

		if(this.buttonSelectClear) {
			this.buttonSelectClear.map((item) => item.addEventListener('click', (event) => {
				this.checkboxes.map((checkbox) => {
					checkbox.checked = false;
				});
				this.buttonSelectClear.map((button) => {
					button.classList.remove('d-block');
				});
				this.submitButtonModal.map((button)=>{
					button.classList.add('button--disabled');
				})
			}));
		}

		if(this.submitButtonModal) {
			this.submitButtonModal.map((item) => item.addEventListener('click', (event) => {
				const element = event.target;
				if(!element.classList.contains('button--disabled')){
					const form = element.closest('form');
					const formFields: any = form.querySelectorAll('input, select');
					let formFieldsArray = [];
					for (let index = 0; index < formFields.length; index++) {
						let elementInput = formFields[index];
						if(elementInput.getAttribute('type') !== 'checkbox') {
							formFieldsArray.push(elementInput);
						}
					}
					const validation = this.validationService.validate(formFieldsArray);
					if(typeof validation === 'object'){
						if (validation.valid) {
							this.actionModalNewsletter(form);
						}
					}else{
						const valid = Array.from(form.querySelectorAll(".form__group--error"));
						if (valid.length == 0) {
							this.actionModalNewsletter(form);
						}
					}
				}
			}));
		}

		if(this.checkboxes) {
			let selectedCheckboxes = this.selectedCheckboxes;
			this.checkboxes.map((checkbox) => checkbox.addEventListener('click', (event)=>{
				let valid = false;
				this.checkboxes.map((item) => {
					if(item.checked) {
						valid = true;
					}
				})
				if(valid) {
					this.buttonSelectClear.map((button) => {
						button.classList.add('d-block');
					});
					this.submitButtonModal.map((button)=>{
						button.classList.remove('button--disabled');
					});
				}else{
					this.submitButtonModal.map((button)=>{
						button.classList.add('button--disabled');
					})
				}
			}));
		}

	}

	openModal(modalName = '') {

		this.modalContainers.map((item)=> {

			let itemId = item.getAttribute('id');
			item.classList.remove('modal--open');
			item.classList.add('modal--closed');

			if(modalName) {

				if(modalName === itemId) {

					this.activeModal = modalName;
					item.classList.remove('modal--closed');
					item.classList.add('modal--open');

				}

			}

		})

	}

	setNewsletterEntry() {

		if (!this.storage) {

		
			this.containerDetailsText.classList.remove('d-block');
			this.containerDetailsText.classList.add('d-none');
	
			this.containerDetailsForm.classList.remove('d-block');
			this.containerDetailsForm.classList.add('d-none');
	
			this.containerDetailsCompleted.classList.remove('d-none');
			this.containerDetailsCompleted.classList.add('d-block');

			localStorage.setItem('newsletter-entry', 'true');
			this.storage = localStorage.getItem('newsletter-entry');

			this.checkNewsletterEntry();

		}else if(this.storage) {
		
			this.containerDetailsText.classList.remove('d-block');
			this.containerDetailsText.classList.add('d-none');
	
			this.containerDetailsForm.classList.remove('d-block');
			this.containerDetailsForm.classList.add('d-none');
	
			this.containerDetailsCompleted.classList.remove('d-none');
			this.containerDetailsCompleted.classList.add('d-block');
			
		} else {

			this.checkNewsletterEntry();

		}

	}

	checkNewsletterEntry() {

		if(this.storage) {

			if(this.textHeading) {

				this.textHeading.innerHTML = "You are already subscribed!";
			}

			if (this.textDescription) {

				this.textDescription.innerHTML = "Try signing up with a different email address";
				
			}

		}

	}

	actionSmallNewsletter(form: any) {

		let operation: any = "subscribeBasic";	
		let formId: any = 'newsletter-simple';	
		let site: any = this.sitename;	
		let email: any = form.querySelector('input.js-newsletter-small-email').value;		
		let formRow: any = form.querySelector('div.row');
		formRow.classList.add('d-none');
		
		let createLoader = document.createElement('div');
		createLoader.innerHTML = '<img class="search__results-busy" src="/file_source/assets/img/spinner.gif">';
		form.appendChild(createLoader);

		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (formId) {
			postData += 'formId=' + formId + '&';
		}
		if (email) {
			postData += 'email=' + email + '&';
		}
		if (site) {
			postData += 'site=' + site + '&';
		}

		let analyticsService = new AnalyticsService();
		let url = "/services/NewsLetterSubscription.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {

			form.querySelector('.search__results-busy').remove();
			formRow.classList.remove('d-none');
			analyticsService.dtmFormComplete('complete', response.data.subscriberId);

			let resultApi = response.data.result;
			if(resultApi.includes('already')) {
				localStorage.setItem('newsletter-entry', 'true');
				this.storage = localStorage.getItem('newsletter-entry');
				this.checkNewsletterEntry();

			}else{

				if (!this.storage) {
				
					this.containerDetailsText.classList.remove('d-block');
					this.containerDetailsText.classList.add('d-none');
			
					this.containerDetailsForm.classList.remove('d-block');
					this.containerDetailsForm.classList.add('d-none');
			
					this.containerDetailsCompleted.classList.remove('d-none');
					this.containerDetailsCompleted.classList.add('d-block');
		
					localStorage.setItem('newsletter-entry', 'true');
					this.storage = localStorage.getItem('newsletter-entry');
		
					this.checkNewsletterEntry();
		
				}else if(this.storage) {
				
					this.containerDetailsText.classList.remove('d-block');
					this.containerDetailsText.classList.add('d-none');
			
					this.containerDetailsForm.classList.remove('d-block');
					this.containerDetailsForm.classList.add('d-none');
			
					this.containerDetailsCompleted.classList.remove('d-none');
					this.containerDetailsCompleted.classList.add('d-block');
					
				} else {
		
					this.checkNewsletterEntry();
		
				}

			}

		}).catch(error => {
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			console.log(error);
		});

	}

	actionModalNewsletter(form: any) {

		let operation: any = "subscribe";	
		let formId: any = this.formId;	
		let site: any = this.sitename;	
		let firstName: any = form.querySelector('input.js-modal-newsletter-firstName').value;	
		let surname: any = form.querySelector('input.js-modal-newsletter-surname').value;
		let email: any = form.querySelector('input.js-modal-newsletter-email').value;		
		let contact: any = form.querySelector('input.js-modal-newsletter-contact').value;	
		let topics: any = "";

		this.selectedCheckboxes = [];
		this.checkboxes.map((item) => {
			if(item.checked) {
				this.selectedCheckboxes.push(item.value);
			}
		});
		
		for (let index = 0; index < this.selectedCheckboxes.length; index++) {
			const topic = this.selectedCheckboxes[index];
			if((index + 1) === this.selectedCheckboxes.length){
				topics += topic;
			}else{
				topics += topic + ",";
			}
		}

		let postData = '';
		if (operation) {
			postData += 'operation=' + operation + '&';
		}
		if (formId) {
			postData += 'formId=' + formId + '&';
		}
		if (firstName) {
			postData += 'firstName=' + firstName + '&';
		}
		if (surname) {
			postData += 'surname=' + surname + '&';
		}
		if (email) {
			postData += 'email=' + email + '&';
		}
		if (contact) {
			postData += 'contact=' + contact + '&';
		}
		if (topics) {
			postData += 'topics=' + topics + '&';
		}
		if (site) {
			postData += 'site=' + site + '&';
		}

		let analyticsService = new AnalyticsService();
		let url = "/services/NewsLetterSubscription.jsp";
		const config = {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
				"Access-Control-Allow-Origin": "*",
				'X-Requested-With': 'XMLHttpRequest'
			}
		}

		// service
		this.formsService.postForm(url, postData, config).then(response => {
			localStorage.setItem('sbgNewsletterSubscriberId', response.data.subscriberId);
			analyticsService.dtmFormComplete('complete', response.data.subscriberId);
		}).catch(error => {
			analyticsService.dtmRecordSiteError('noerrorcode|service failure occured|' + url);
			console.log(error);
		});

		this.containerModalForm.classList.add('d-none');
		this.containerModalLoader.classList.remove('d-none');
		setTimeout(()=>{
			this.containerModalLoader.classList.add('d-none');
			this.containerModalSuccess.classList.remove('d-none');
		},2000);

	}

	resetForms() {

		if(this.forms) {

			this.forms.map((form) => {
				
				form.reset();

				let formGroups = Array.from(form.querySelectorAll('.form__group--error'));
				formGroups.map((formGroup: any) => {
					formGroup.classList.remove('form__group--error');
				});

			});
			
		}

		this.buttonSelectClear.map((button) => {
			button.classList.remove('d-block');
		});

		this.submitButtonModal.map((button)=>{
			button.classList.add('button--disabled');
		});

		if(this.containerModalSuccess){
			this.containerModalSuccess.classList.add('d-none');
		}

		if(this.containerModalForm){
			this.containerModalForm.classList.remove('d-none');
		}

	}


}


// WEBPACK FOOTER //
// ./components/newsletter/newsletter.component.ts